import React, { useState, useEffect } from "react";
import NewsCard from "./homeComp/NewsCard";
import NewsCardBuffer from "./homeComp/NewsCardBuffer";
import { db } from "../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import Feature from "./homeComp/Feature";
import FeatureCard from "./homeComp/FeatureCards";
import FacebookSection from "./homeComp/FacebookSection";
import logo from "../res/logo.png";

function Home(props) {
  const features = props.features;
  const [newsLoading, setNewsLoading] = useState(true);
  const [landingText, setLandingText] = useState([
    {
      id: "",
      text: "...",
    },
  ]);
  const [news, setNews] = useState([
    {
      title: "title",
      date: "date",
      newsBody: "body",
      lead: "lead",
      url: "url",
    },
  ]);

  const [announce, setAnnounce] = useState([
    {
      title: "title",
      date: "date",
    },
  ]);

  const [activeFeatureTitle, setActiveFeatureTitle] = useState("Loading...");

  const handleFeatureChange = (title) => {
    setActiveFeatureTitle(title);
  };

  const newsRef = collection(db, "news");
  const announceRef = collection(db, "announcements");
  const landingRef = collection(db, "landingtext");

  const getNews = async () => {
    const data = await getDocs(newsRef);
    setNews(
      data.docs
        .map((doc) => ({ ...doc.data(), id: doc.id }))
        .sort((a, b) => {
          let da = new Date(a.date);
          let db = new Date(b.date);
          return db - da;
        })
    );
    setNewsLoading(false);
  };

  const getLandingText = async () => {
    const data = await getDocs(landingRef);
    setLandingText(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  const getAnnouncements = async () => {
    const data = await getDocs(announceRef);
    setAnnounce(
      data.docs
        .map((doc) => ({ ...doc.data(), id: doc.id }))
        .sort((a, b) => {
          let da = new Date(a.date);
          let db = new Date(b.date);
          return db - da;
        })
    );
  };

  useEffect(() => {
    document.title = "Philippine Engineering and Agro-Industrial College, Inc.";
    props.setActivePage();

    getNews();
    getLandingText();
    getAnnouncements();
    // eslint-disable-next-line
  }, []);

  const renderFeatures = () => {
    if (features[0].id) {
      return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((val, key) => {
            return <FeatureCard data={val} key={key} />;
          })}
        </div>
      );
    } else {
      return <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">Loading Features</div>;
    }
  };

  const renderNewsCard = () => {
    return newsLoading ? (
      <NewsCardBuffer />
    ) : (
      <React.Fragment>
        {news.map((val, key) => {
          return (
            <NewsCard
              key={key}
              title={val.title}
              desc={val.lead}
              url={val.url}
            />
          );
        })}
      </React.Fragment>
    );
  };

  return (
    <main className="flex flex-col items-center gap-10 w-full" role="main">
      <section
        className="w-full bg-gradient-to-r from-[#eaac38] to-[#c48918] dark:from-[#eaac38] dark:to-[#c48918]"
        aria-labelledby="home-hero-heading"
      >
        <div className="flex w-full flex-col md:flex-row items-stretch justify-between  gap-6">
          <div className="w-full md:w-full h-[calc(100vh-96px)] justify-center items-center md:justify-start md:items-stretch">            
            <Feature features={features} onFeatureChange={handleFeatureChange} />
          </div>
          
        </div>
      </section>
      
      {/* Logo Showcase Section */}
      <section 
        className="w-full bg-white dark:bg-gray-900"
        aria-labelledby="logo-showcase-heading"
      >
        <div className="mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between px-4 py-16 sm:px-6 lg:px-8 lg:py-20 gap-8 lg:gap-12">
          <div className="flex-shrink-0 text-center lg:text-left">
            <img
              src={logo}
              alt="PEACI Logo"
              className="mx-auto lg:mx-0 h-56 sm:h-64 lg:h-80 xl:h-96 w-auto transition-transform duration-300 ease-out hover:scale-105"
            />
          </div>
          <header className="flex flex-col items-center lg:items-start justify-center gap-3 text-center lg:text-left flex-1">
            <h1
              id="logo-showcase-heading"
              className="font-black text-gray-900 dark:text-gray-100 text-2xl sm:text-3xl lg:text-4xl xl:text-5xl tracking-tight leading-tight"
            >
              PHILIPPINE ENGINEERING AND AGRO-INDUSTRIAL COLLEGE, INC.
            </h1>
            <p className="font-light text-gray-600 dark:text-gray-300 text-sm sm:text-base lg:text-lg xl:text-xl leading-relaxed max-w-3xl">
              {landingText[0].text}
            </p>
            <div className="flex flex-col items-center lg:items-start gap-2 mt-2">
              <h2 className="text-lg sm:text-xl lg:text-2xl text-gray-800 dark:text-gray-100 font-semibold">
                Get Your Degree Now!
              </h2>
              <a
                href="../programs"
                className="inline-flex items-center justify-center rounded-lg bg-[#eaac38] hover:bg-[#c48918] dark:bg-[#eaac38] dark:hover:bg-[#eaac38] px-6 py-2 text-sm sm:text-base font-semibold text-white shadow-md transition-colors transition-transform duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#e0a430] focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-900"
              >
                FIND OUT MORE
              </a>
            </div>
          </header>
        </div>
      </section>
      
      <section
        className="w-full bg-gray-50 dark:bg-gray-900/30 py-10 sm:py-12"
        aria-label="Featured content, news, and announcements"
      >
        <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-10">
            <section
              className="scrollbar-hover-container flex min-h-0 flex-col lg:col-span-2"
              aria-labelledby="home-features-heading"
            >
              <header className="mb-5 shrink-0">
                <h2
                  id="home-features-heading"
                  className="font-bold text-xl sm:text-2xl text-gray-900 dark:text-gray-100"
                >
                  Features
                </h2>
                <div
                  className="mt-1 h-0.5 w-16 rounded-full bg-[#eaac38]"
                  aria-hidden
                />
              </header>
              <div className="scroll-fade-wrapper min-h-0 lg:max-h-[420px]">
                <div className="scrollbar-hover flex flex-col gap-4 overflow-y-scroll h-full">
                  {renderFeatures()}
                </div>
              </div>
            </section>
            <div className="flex flex-col gap-8">
              <section
                className="scrollbar-hover-container flex min-h-0 flex-col"
                aria-labelledby="home-news-heading"
              >
                <header className="mb-5 shrink-0">
                  <h2
                    id="home-news-heading"
                    className="font-bold text-xl sm:text-2xl text-gray-900 dark:text-gray-100"
                  >
                    News
                  </h2>
                  <div
                    className="mt-1 h-0.5 w-16 rounded-full bg-[#eaac38]"
                    aria-hidden
                  />
                </header>
                <div className="scroll-fade-wrapper min-h-0 lg:max-h-[360px]">
                  <div className="scrollbar-hover flex flex-col gap-4 overflow-y-scroll h-full">
                    {renderNewsCard()}
                  </div>
                </div>
              </section>
              <aside
                className="scrollbar-hover-container flex min-h-0 flex-col lg:max-h-[360px]"
                aria-labelledby="home-announcements-heading"
              >
                <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800 dark:shadow-none">
                  <header className="mb-4 shrink-0 p-5 pb-0">
                    <h2
                      id="home-announcements-heading"
                      className="font-bold text-xl sm:text-2xl text-gray-900 dark:text-gray-100"
                    >
                      Announcements
                    </h2>
                    <div
                      className="mt-1 h-0.5 w-16 rounded-full bg-amber-500"
                      aria-hidden
                    />
                  </header>
                  <div className="scroll-fade-wrapper min-h-0 flex-1 overflow-hidden">
                    <ul className="scrollbar-hover h-full space-y-3 overflow-y-scroll p-5 pt-4 text-sm leading-relaxed text-stone-700 dark:text-stone-200 sm:text-base">
                      {announce.map((val, key) => (
                        <li
                          key={key}
                          className="border-l-2 border-[#eaac38]/50 pl-3 py-0.5"
                        >
                          {val.title}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </aside>
            </div>
            <div className="flex min-h-0 flex-col">
              <FacebookSection />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
